@if (sortDirection() === 'asc') {
  <mat-icon class="!mx-auto">arrow_upward</mat-icon>
} @else {
  <mat-icon class="!mx-auto">arrow_downward</mat-icon>
}
